import React from 'react'
import { Navigate } from 'react-router-dom'
import { useUser } from '../../hooks/useUser'

const GuestGuard: React.FC = (props) => {
  const user = useUser()

  if (user.data) {
    return <Navigate to="/" />
  }

  return <>{props.children}</>
}

export default GuestGuard
